import { useAuth } from '@clerk/react';
import { Navigate, useLocation } from 'react-router-dom';
import { colors } from '@yorukiri/ui/tokens';
import { App } from '../App';

export function ProtectedRoute() {
  const { isLoaded, isSignedIn } = useAuth();
  const location = useLocation();

  if (!isLoaded) {
    return (
      <div
        style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: colors.ink3,
          fontSize: 13,
          background: colors.bg,
        }}
      >
        …
      </div>
    );
  }

  if (!isSignedIn) {
    const qs = new URLSearchParams({ redirect: location.pathname + location.search });
    return <Navigate to={`/sign-in?${qs}`} replace />;
  }

  return <App />;
}
